/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Review_StatusInputs */

const cs_gdpr_review_status = /** @type {(inputs: Gdpr_Review_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav`)
};

const en_gdpr_review_status = /** @type {(inputs: Gdpr_Review_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Gdpr_Review_StatusInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_status = /** @type {((inputs?: Gdpr_Review_StatusInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_StatusInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_status(inputs)
	return cs_gdpr_review_status(inputs)
});